import { useEffect } from "react";
import { homepageCopy } from "../content/homepageCopy";
import { investorsCopy } from "../content/investorsCopy";

function upsertMeta(attr, key, content) {
  const selector = `meta[${attr}="${key}"]`;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function canonicalUrl(path) {
  const origin = homepageCopy.meta.siteOrigin.replace(/\/$/, "");
  if (!path || path === "/") return `${origin}/`;
  return `${origin}${path.startsWith("/") ? path : `/${path}`}`;
}

function normalizePath(pathname) {
  if (!pathname || pathname === "/") return "/";
  return pathname.replace(/\/+$/, "");
}

export function getStaticRouteMeta(pathname) {
  pathname = normalizePath(pathname);
  if (pathname === "/") {
    return {
      title: homepageCopy.meta.title,
      description: homepageCopy.meta.description,
      ogDescription: homepageCopy.meta.ogDescription,
      path: "/",
    };
  }
  if (pathname === "/blog") {
    return { ...homepageCopy.pages.blog, path: "/blog" };
  }
  if (pathname === "/privacy") {
    return { ...homepageCopy.pages.privacy, path: "/privacy" };
  }
  if (pathname === "/terms") {
    return { ...homepageCopy.pages.terms, path: "/terms" };
  }
  if (pathname === "/investors") {
    return {
      title: investorsCopy.meta.title,
      description: investorsCopy.meta.description,
      path: "/investors",
      robots: "noindex, nofollow",
    };
  }
  if (pathname.startsWith("/blog/")) {
    return null;
  }
  return { ...homepageCopy.pages.notFound, path: pathname };
}

export function useDocumentMeta(meta) {
  useEffect(() => {
    if (!meta) return undefined;

    const title = meta.title;
    const description = meta.description;
    const ogDescription = meta.ogDescription || description;
    const url = canonicalUrl(meta.path);

    document.title = title;
    upsertMeta("name", "description", description);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", ogDescription);
    upsertMeta("property", "og:url", url);
    upsertCanonical(url);
    if (meta.robots) {
      upsertMeta("name", "robots", meta.robots);
    }

    return () => {
      document.title = homepageCopy.meta.title;
      if (meta.robots) {
        document.head.querySelector('meta[name="robots"]')?.remove();
      }
    };
  }, [meta?.title, meta?.description, meta?.ogDescription, meta?.path, meta?.robots]);
}
